// extracted by mini-css-extract-plugin
export default {"Container":"Styles_Container__IHPne","Tutor":"Styles_Tutor__PklNU","calender":"Styles_calender__E2HTK"};